.table {
    border-collapse: collapse;
    td {
        padding-bottom: 5px;
    }
}
